export default "__VITE_ASSET__DSECg0$B__"